import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
	selector: 'page-order-history',
	templateUrl: 'order-history.html'
})

export class OrderHistoryPage{
	constructor(private nav: NavController){
		
	}
}


// WEBPACK FOOTER //
// ./src/pages/orders/order-history.ts